module.exports = __webpack_public_path__ + "img/logo.4218b228.png";